/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { VirtualDndViewportPreviewDirective } from './virtual-dnd-viewport-preview.directive';
import {
  VirtualDndDragEndedEvent,
  VirtualDndDragMovedEvent,
  VirtualDndDragStartedEvent,
  VirtualDndService,
  VirtualDndViewport,
  VirtualDndZoneEvent,
} from './virtual-dnd.service';

@Directive({
  selector: '[ghVirtualDndViewport]',
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    'style.position': 'relative',
  },
  providers: [VirtualDndService],
})
export class VirtualDndViewportDirective implements VirtualDndViewport {
  @Input('ghVirtualViewportPreview') preview: VirtualDndViewportPreviewDirective;
  @Input('ghVirtualViewportTouchDelay') touchDelay: number;
  @Input('ghVirtualDndViewportDisabled') disabled: boolean;

  @Output() dragStarted = new EventEmitter<VirtualDndDragStartedEvent>();
  @Output() dragMoved = new EventEmitter<VirtualDndDragMovedEvent>();
  @Output() dragEnded = new EventEmitter<VirtualDndDragEndedEvent>();
  @Output() zoneEntered = new EventEmitter<VirtualDndZoneEvent>();
  @Output() zoneExited = new EventEmitter<VirtualDndZoneEvent>();

  constructor(private elementRef: ElementRef,
              private virtualDnd: VirtualDndService) {
    this.virtualDnd.registerViewport(this);
  }

  get element(): HTMLElement {
    return this.elementRef.nativeElement;
  }
}
